module.exports = __webpack_public_path__ + "img/3.2c6bc276.jpg";